// React 19 compatibility polyfill
// This file provides compatibility shims for removed React features

import ReactDOM from "react-dom";

// Create a more robust findDOMNode replacement
const findDOMNodeCompat = function (node) {
  // Handle null/undefined
  if (!node) return null;

  // If it's already a DOM node, return it
  if (node && node.nodeType) return node;

  // If it's a ref with current property, return the current
  if (node && typeof node.current !== "undefined") {
    return node.current;
  }

  // Try to find DOM node through React fiber (React 16+)
  if (node && node._reactInternalFiber) {
    let fiber = node._reactInternalFiber;
    while (fiber) {
      if (fiber.stateNode && fiber.stateNode.nodeType) {
        return fiber.stateNode;
      }
      fiber = fiber.child;
    }
  }

  // For React 16+ with _reactInternalInstance
  if (node && node._reactInternalInstance) {
    let instance = node._reactInternalInstance;
    while (instance) {
      if (instance.stateNode && instance.stateNode.nodeType) {
        return instance.stateNode;
      }
      instance = instance.child;
    }
  }

  // Try to get DOM node from React component (React 19+ approach)
  if (node && typeof node === "object" && node.constructor) {
    // For class components, try to find the DOM node
    if (node.refs && Object.keys(node.refs).length > 0) {
      // If component has refs, try to find the first DOM element ref
      for (let ref in node.refs) {
        if (node.refs[ref] && node.refs[ref].nodeType) {
          return node.refs[ref];
        }
      }
    }

    // If this is a functional component or we can't find refs, return null
    console.warn("findDOMNode: Unable to find DOM node for component:", node);
    return null;
  }

  // Fallback: return the node itself if it might be a DOM element
  return node;
};

// Make it globally available
if (typeof window !== "undefined") {
  window.findDOMNodeCompat = findDOMNodeCompat;
}

// Provide findDOMNode if it doesn't exist (React 19 compatibility)
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = findDOMNodeCompat;
  console.log("✓ ReactDOM.findDOMNode polyfill loaded");
}

// Provide unstable_renderSubtreeIntoContainer if it doesn't exist
if (!ReactDOM.unstable_renderSubtreeIntoContainer) {
  ReactDOM.unstable_renderSubtreeIntoContainer = function (parent, element, container, callback) {
    if (!container._reactRoot) {
      const { createRoot } = require("react-dom/client");
      container._reactRoot = createRoot(container);
    }
    container._reactRoot.render(element);
    if (callback) callback();
  };
  console.log("✓ ReactDOM.unstable_renderSubtreeIntoContainer polyfill loaded");
}

// Provide unmountComponentAtNode if it doesn't exist
if (!ReactDOM.unmountComponentAtNode) {
  ReactDOM.unmountComponentAtNode = function (container) {
    if (container._reactRoot) {
      container._reactRoot.unmount();
      container._reactRoot = null;
      return true;
    }
    return false;
  };
  console.log("✓ ReactDOM.unmountComponentAtNode polyfill loaded");
}
